
import { defineComponent, watch } from 'vue'

export default defineComponent(
{
    name: 'Button',
    emits: ['buttonActionTriggered'],
    props:
    {
        type:
        {
            type: String,
            default: 'button'
        },
        disabled:
        {
            type: Boolean,
            default: false
        },
        preventDoubleClick:
        {
            type: Boolean,
            default: true
        }
    },
    setup(props, { emit })
    {
        // Set consts:
        const KEY_SPACE = 32
        const DEBOUNCE_TIMEOUT_IN_SECONDS = 1
        let debounceFormSubmitTimer: number|null = null
        // Handle click event:
        const handleClick = () =>
        {
            if(!props.preventDoubleClick || debounceFormSubmitTimer === null)
            {
                actionButton()
            }
        }
        // Handle space key event:
        const handleKeydown = (event: KeyboardEvent) =>
        {
            if(event.keyCode === KEY_SPACE && props.type === 'button')
            {
                actionButton()
            }
            else
            {
                return false
            }
        }
        // Handle button action:
        const actionButton = () =>
        {
            debounceFormSubmitTimer = setTimeout(() =>
            {
                debounceFormSubmitTimer = null
            }, DEBOUNCE_TIMEOUT_IN_SECONDS * 1000)
            emit('buttonActionTriggered')
        }
        // Return data:
        return {
            handleClick,
            handleKeydown
        }
    }
})
